export const getFormTemplates = (t) => [
  {
    deleteStatus: false,
    questions: [
      {
        options: [
          { optionText: t("Yes"), placeholder: "Option 1" },
          { optionText: t("No") },
        ],
        formType: "MULIPLE_CHOICE",
        id: 1,
        question: t("How can we contact you?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "Option 1" }],
        formType: "SHORT_ANS",
        id: 2,
        question: t("Full Name"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [
          { optionText: t("Email") },
          { optionText: t("Phone") },
          { optionText: t("Mail") },
        ],
        formType: "CHECKBOX",
        id: 3,
        question: t("Preferred Contact Method"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: t("Yes") }, { optionText: t("No") }],
        formType: "MULIPLE_CHOICE",
        id: 4,
        question: t("Do you have any dietary restrictions?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Contact Information Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Contact Information"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [
          { optionText: t("Yes"), placeholder: "Option 1" },
          { optionText: t("No") },
        ],
        formType: "MULIPLE_CHOICE",
        id: 1,
        question: t("Will you be attending the event?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "Option 1" }],
        formType: "SHORT_ANS",
        id: 2,
        question: t("Full Name"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [
          { optionText: t("Email") },
          { optionText: t("Phone") },
          { optionText: t("Mail") },
        ],
        formType: "CHECKBOX",
        id: 3,
        question: t("Preferred Contact Method"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: t("Yes") }, { optionText: t("No") }],
        formType: "MULIPLE_CHOICE",
        id: 4,
        question: t("Any dietary restrictions?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Event Registration Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Event Registration"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [
          { optionText: "1" },
          { optionText: "2" },
          { optionText: "3" },
          { optionText: "4" },
          { optionText: "5" },
        ],
        formType: "MULIPLE_CHOICE",
        id: 1,
        question: t("Rate your overall experience (1-5):"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 2,
        question: t("What did you enjoy the most?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 3,
        question: t("What could be improved?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: t("Yes") }, { optionText: t("No") }],
        formType: "MULIPLE_CHOICE",
        id: 4,
        question: t("Would you recommend this event?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Event Feedback Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Event Feedback"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [
          { optionText: t("High") },
          { optionText: t("Medium") },
          { optionText: t("Low") },
        ],
        formType: "MULIPLE_CHOICE",
        id: 1,
        question: t("Urgency of the request:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 2,
        question: t("Describe the nature of your work request:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "FILE_UPLOAD",
        id: 3,
        question: t("Attach any relevant documents:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "DATE_PICKER",
        id: 4,
        question: t("Preferred completion date:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Work Request Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Work Request"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [
          { optionText: "1" },
          { optionText: "2" },
          { optionText: "3" },
          { optionText: "4" },
          { optionText: "5" },
        ],
        formType: "MULIPLE_CHOICE",
        id: 1,
        question: t("How satisfied are you with our service (1-5)?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 2,
        question: t("What aspects do you think we excel in?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 3,
        question: t("Is there anything we could improve?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: t("Yes") }, { optionText: t("No") }],
        formType: "MULIPLE_CHOICE",
        id: 4,
        question: t("Would you use our services again?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Customer Feedback Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Customer Feedback"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 1,
        question: t("Position applied for:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "FILE_UPLOAD",
        id: 2,
        question: t("Upload your resume:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 3,
        question: t("Describe your relevant experience:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 4,
        question: t("What motivates you to apply for this position?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 5,
        question: t("Expected salary:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Job Application Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Job Application"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 1,
        question: t("Product/Service Name:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "NUMBER_INPUT",
        id: 2,
        question: t("Quantity:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 3,
        question: t("Preferred color/size (if applicable):"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 4,
        question: t("Delivery address:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 5,
        question: t("Additional comments:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Order Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Order Form"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [
          { optionText: "1" },
          { optionText: "2" },
          { optionText: "3" },
          { optionText: "4" },
          { optionText: "5" },
        ],
        formType: "MULIPLE_CHOICE",
        id: 1,
        question: t("Subject of Assessment:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "MULIPLE_CHOICE",
        id: 2,
        question: t("Rate your proficiency (1-5):"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 3,
        question: t("Describe your strengths in this area:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 4,
        question: t("Areas for improvement:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 5,
        question: t("Any additional comments:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Assessment Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Assessment"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 1,
        question: t("Topic of the worksheet:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 2,
        question: t("Provide your answers/solutions:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "MULIPLE_CHOICE",
        id: 3,
        question: t("Are there any challenges you faced?"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 4,
        question: t("Additional comments or thoughts:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "FILE_UPLOAD",
        id: 5,
        question: t("Attach any supporting materials:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Worksheet Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Worksheet"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
  {
    deleteStatus: false,
    questions: [
      {
        options: [{ optionText: "" }],
        formType: "DATE_TIME_PICKER",
        id: 1,
        question: t("Event date and time:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "TEXTAREA",
        id: 2,
        question: t("Venue address:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "DATE_PICKER",
        id: 3,
        question: t("RSVP by (date):"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 4,
        question: t("Dress code (if any):"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
      {
        options: [{ optionText: "" }],
        formType: "SHORT_ANS",
        id: 5,
        question: t("Special instructions or requests:"),
        question_placeholder: t("Question"),
        requiredSwitch: false,
      },
    ],
    updatedAt: "2024-02-07T07:05:34.507Z",
    status: true,
    assignedDetails: [],
    description: t("Party Invite Form"),
    clientId: "WATSKIG",
    insertedAt: "2024-02-07T07:05:34.507Z",
    title: t("Party Invite"),
    img: "https://form-template1.s3.ap-south-1.amazonaws.com/template-image1.png",
  },
];
